import React, { Fragment } from "react";
import { Field } from "react-final-form";
import { withStyles } from "@material-ui/core/styles";

import TermsPrivacyFieldStyle from "./TermsPrivacyField.style";
import { Error, RenderCheckbox, LinkLabel } from "./Elements";
import T from "Translate";
import Stack from "Common/Stack/Stack";
import MarketsSvc from "Services/markets/marketsSvc";

const TermsConditionsField = props => {
    const { onChange, validate, country, lang, classes, values } = props;

    const TermsConditionsLabel = () => {
        if (MarketsSvc.hasLongTermsConditions(country)) {
            return (
                <div className={`${classes.privacy_policy} text-upperCase black`}>
                    <T>i_agree_unicity_member</T>&nbsp;
                    <LinkLabel termsCondition country={country} language={lang} style={{ color: "#75A4D3" }}>
                        <T>terms_conditions</T>
                    </LinkLabel>
                    &nbsp;<T>and_the</T>&nbsp;
                    <LinkLabel style={{ color: "#75A4D3" }}>
                        <T>privacy_notice</T>
                    </LinkLabel>
                    *
                </div>
            );
        }

        return (
            <div className={classes.privacy_policy}>
                <T>i_agree_unicity_member</T>&nbsp;
                <LinkLabel termsCondition country={country} language={lang}>
                    <T>terms_conditions</T>
                </LinkLabel>
            </div>
        );
    };

    return (
        <Fragment>
            <Stack display="flex" alignItems="start">
                <Field
                    name="termsCondition"
                    component={RenderCheckbox}
                    type="checkbox"
                    label="Employed"
                    onChange={onChange}
                    validate={validate}
                    dataTestId="terms_and_conditions"
                />
                <TermsConditionsLabel />
            </Stack>
            <Error
                name="termsCondition"
                className={classes.termsError}
                value={values}
                dataTestId="error_terms_and_conditions"
            />
        </Fragment>
    );
};
export default withStyles(TermsPrivacyFieldStyle)(TermsConditionsField);



// WEBPACK FOOTER //
// ./src/components/StartContainer/TermsPrivacyField/TermsConditionsField.js